/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import BackgroundPanel from "./BackgroundPanel";
import ImageButton from "./ImageButton";

function Carousel({ width, height, pages, arrows, aframeClasses, ...otherAttributes }) {
    const [currentPage, setCurrentPage] = useState(0);
    const pagesLength = pages.length;

    const generatePage = () => {
        return (
            <a-entity>
                {pages[currentPage]}
                {pages.length > 1 && (
                    <>
                        <ImageButton
                            aframeClasses={aframeClasses}
                            width={width * (arrows === "bottom" ? 0.25 : 0.15)}
                            height={height * 0.1}
                            src="#Back"
                            disabled={!currentPage}
                            onClickHandler={() =>
                                setCurrentPage((prev) => prev - 1)
                            }
                            position={
                                arrows === "bottom"
                                    ? `${-width * 0.3} ${-height * 0.4} 0`
                                    : `${-width * 0.4} ${-height * 0.15} 0`
                            }
                        />
                        <ImageButton
                            aframeClasses={aframeClasses}
                            width={width * (arrows === "bottom" ? 0.25 : 0.15)}
                            height={height * 0.1}
                            src="#Back"
                            rotation="0 0 180"
                            disabled={pagesLength - 1 === currentPage}
                            onClickHandler={() =>
                                setCurrentPage((prev) => prev + 1)
                            }
                            position={
                                arrows === "bottom"
                                    ? `${width * 0.3} ${-height * 0.4} 0`
                                    : `${width * 0.4} ${-height * 0.15} 0`
                            }
                        />
                    </>
                )}
            </a-entity>
        );
    };

    return (
        <BackgroundPanel width={width} height={height} {...otherAttributes}>
            {generatePage()}
        </BackgroundPanel>
    );
}

Carousel.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

export default Carousel;
